export default {
    "Welcome to React": "Bem vindos ao React e  react-i18next",
    description: {
        part1: "Editar <1>src/App.js</1> e salvar para recarregar.",
        part2: "Aprender React",
    },
};
